import React, { useRef, useState } from 'react'
import { Button, Form, Input, Col, Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { PlusOutlined } from '@ant-design/icons'

export function AddComment ({ callRequest = () => Promise.resolve({}), handleReload, maxLength = 255 }) {
  const { t } = useTranslation()
  const [showInput, setShowInput] = useState(false)
  const [isSubmiting, setSubmiting] = useState(false)
  const [form] = Form.useForm()
  const inputRef = useRef(null)

  const onClickAddComment = () => {
    setShowInput(true)
    setTimeout(() => {
      inputRef.current?.focus({ cursor: 'end' })
    }, 100)
  }
  const onCancelComment = () => {
    setShowInput(false)
  }
  const onFinish = async () => {
    const { notes } = form.getFieldsValue()
    const promise = callRequest(notes)
    setSubmiting(true)
    const { status } = await promise
    setSubmiting(false)
    if (status === 200) {
      setShowInput(false)
      form.setFieldsValue({ notes: '' })
      handleReload()
    }
  }
  if (!showInput) {
    return (
      <Button
        icon={<PlusOutlined />}
        ghost
        disabled={showInput}
        onClick={onClickAddComment}
        className='d-inline-flex align-items-center lms-button-submit'
      >
        {t('page.class.text.add_comment')}
      </Button>
    )
  }
  return (
    <Form form={form} initialValues={{}} onFinish={onFinish} className='p-0'>
      <Form.Item
        name='notes'
        rules={[
          {
            required: true,
            message: t('page.class.text.comment_is_required')
          }
        ]}
      >
        <Input.TextArea
          ref={inputRef}
          rows={3}
          maxLength={maxLength}
          placeholder={t('page.class.placeholder.input_comment')}
        />
      </Form.Item>
      <Row>
        <Col
          span={24}
          style={{
            textAlign: 'center'
          }}
        >
          <Button
            type='primary'
            className='mr-2'
            loading={isSubmiting}
            onClick={onFinish}
          >
            {t('common.label.send_comment')}
          </Button>
          <Button disabled={isSubmiting} onClick={onCancelComment}>
            {t('common.label.cancel')}
          </Button>
        </Col>
      </Row>
    </Form>
  )
}
